/* __next_internal_client_entry_do_not_use__ ClickCounterContext,ClickCounterContextProvider auto */ import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useReducer } from "react";
const initialState = {
    clicks: 0
};
const reducer = (state, action)=>{
    switch(action.type){
        case "ADD_CLICK":
            return {
                ...state,
                clicks: state.clicks + 1
            };
        default:
            return state;
    }
};
export const ClickCounterContext = /*#__PURE__*/ createContext({
    state: initialState,
    dispatch: (action)=>null
});
export const ClickCounterContextProvider = (param)=>{
    let { children } = param;
    const [state, dispatch] = useReducer(reducer, initialState);
    return(//@ts-ignore
    /*#__PURE__*/ _jsx(ClickCounterContext.Provider, {
        value: {
            state,
            dispatch
        },
        children: children
    }));
};
